module.exports = __webpack_public_path__ + "static/Dipinjit.9e3c35aa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/team/Dipinjit.jpg
// module id = 1296
// module chunks = 137408898365125